<div class="_wf-ss-mainsection">
  <div class="_wf-ssrgtmainsec">
    <div class="_wf-ss-connecthdtxt">
      <div class="text-block-284">Connect with Us</div>
      <div class="_wf-ss-mainshadowdiv">
        <div class="_wf-ss-tickettxt">
          <div class="_wf-ss-tickethone">
            <div class="text-block-247 suroort">Raise a ticket or talk to our support team</div>
            <div class="_wf-ss-phnumberborder">
              <div class="text-block-241">9069113330</div><img src="assets/images/ph-blue_1ph-blue.png" loading="lazy" width="15" alt="" class="image-15">
            </div>
          </div>
        </div>
        <div class="_wf-ss-ticketmaindiv">
          <div class="_wf-ss-smallboxmain _wf-ss-webdiv">
            <div class="_wf-ss-saleblk" (click)="onNavigate()">
              <div class="text-block-243">Raise a <br>ticket<span class="text-span-30"></span></div>
              <div class="_wf-ss-saleimage"><img src="assets/images/ticket2_1ticket2.png" loading="lazy" width="49" height="49" alt=""></div>
            </div>
            <div class="_wf-ss-ortxt">
              <div>or</div>
            </div>
            <div class="_wf-ss-saleblk">
              <div class="text-block-243">Dial 1 for<br><span class="text-span-30">Sales</span></div>
              <div class="_wf-ss-saleimage"><img src="assets/images/sales_2sales.png" loading="lazy" width="49" height="49" alt=""></div>
            </div>
            <div class="_wf-ss-extendsupport">
              <div class="_wf-ss-saleblk _wf-ss-saleblksce">
                <div class="text-block-243">Dial 2 for<br><span class="text-span-30">Support</span></div>
                <div class="_wf-ss-saleimage"><img src="assets/images/support_2support.png" loading="lazy" width="49" height="49" alt=""></div>
              </div>
              <div class="_wf-ss-dropdownbox" (click)="arrowClick(dropdownicon)">
                <div class="_wf-ss-dropdownicon" id="dropdownicon" #dropdownicon><img src="assets/images/down-arrow-white_1down-arrow-white.png" loading="lazy" alt="" class="image-16"></div>
              </div>
            </div>
            <div class="_wf-ss-saleblk _wf-ss-saleblksce">
              <div class="text-block-243">Dial 3 for<br><span class="text-span-30">Billing</span></div>
              <div class="_wf-ss-saleimage"><img src="assets/images/Billing_2Billing.png" loading="lazy" width="49" height="49" alt=""></div>
            </div>
            <div class="_wf-ss-saleblk _wf-ss-saleblksce">
              <div class="text-block-243">Dial 4 for<br><span class="text-span-30">Others</span></div>
              <div class="_wf-ss-saleimage"><img src="assets/images/others_1others.png" loading="lazy" width="49" height="49" alt=""></div>
            </div>
          </div>
        </div>
        @if (showSupport) {
          <div class="_wf-ss-supportdiv">
            <div class="_wf-ss-blkhd _wf-ss-secblkhd">
              <div class="text-block-240">Support menu extensions</div>
            </div>
            <div class="_wf-ss-supportblksmain _wf-ss-webdiv">
              <div class="_wf-ss-smallmenublk">
                <div class="text-block-244">Extn #1 for<br><span class="text-span-30">Front Desk</span></div><img src="assets/images/desk_1desk.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #2 for<br><span class="text-span-30">Billing</span></div><img src="assets/images/Billing1_1Billing1.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #3 for<br><span class="text-span-30">IPD</span></div><img src="assets/images/IPD_1IPD.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #4 for<br><span class="text-span-30">Diagnostic</span></div><img src="assets/images/Diagnostic_2Diagnostic.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #5 for<br><span class="text-span-30">Pharmacy &amp; Inventor</span></div><img src="assets/images/inventory_1inventory.png" loading="lazy" width="70" height="70" alt="">
              </div>
            </div>
            <div class="_wf-ss-supportblksmain">
              <div class="_wf-ss-smallmenublk">
                <div class="text-block-244">Extn #6 for<br><span class="text-span-30">Doctor</span></div><img src="assets/images/Doctor_2Doctor.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #7 for<br><span class="text-span-30">ER</span></div><img src="assets/images/ER_1ER.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #8 for<br><span class="text-span-30">Nurse</span></div><img src="assets/images/Nurse_2Nurse.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                <div class="text-block-244">Extn #9 for<br><span class="text-span-30">Others</span></div><img src="assets/images/others1_1others1.png" loading="lazy" width="70" height="70" alt="">
              </div>
              <!-- <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec _wf-ss-hideblk">
              <div class="text-block-244">Extn #1 for<br><span class="text-span-30">Front Desk</span></div><img src="assets/images/Rollout.png" loading="lazy" width="130" height="130" alt="">
            </div> -->
          </div>
        </div>
      }
    </div>
    <div class="_wf-ss-mainshadowdiv _wf-ss-mobileticket">
      <div class="_wf-ss-tickettxt">
        <div class="_wf-ss-tickethone">
          <div class="text-block-247 suroort">Raise a ticket or talk to our support team</div>
          <div class="_wf-ss-phnumberborder">
            <div class="text-block-241">9069113330</div><img src="assets/images/ph-blue_1ph-blue.png" loading="lazy" width="15" alt="" class="image-15">
          </div>
        </div>
      </div>
      <div class="_wf-ss-ticketmaindiv">
        <div class="_wf-ss-smallboxmain _wf-ss-webdiv">
          <div class="_wf-ss-saleblk">
            <div class="text-block-243">Raise a <br>ticket<span class="text-span-30"></span></div>
            <div class="_wf-ss-saleimage"><img src="assets/images/ticket2_1ticket2.png" loading="lazy" width="49" height="49" alt=""></div>
          </div>
          <div class="_wf-ss-ortxt">
            <div>or</div>
          </div>
          <div class="_wf-ss-saleblk">
            <div class="text-block-243">Dial 1 for<br><span class="text-span-30">Sales</span></div>
            <div class="_wf-ss-saleimage"><img src="assets/images/sales_2sales.png" loading="lazy" width="49" height="49" alt=""></div>
          </div>
          <div class="_wf-ss-extendsupport">
            <div class="_wf-ss-saleblk _wf-ss-saleblksce">
              <div class="text-block-243">Dial 2 for<br><span class="text-span-30">Support</span></div>
              <div class="_wf-ss-saleimage"><img src="assets/images/support_2support.png" loading="lazy" width="49" height="49" alt=""></div>
            </div>
            <div data-w-id="7f8f1096-7adf-4fd1-f1f4-ffe41ad4a2b6" class="_wf-ss-dropdownbox"><img src="assets/images/down-arrow-white_1down-arrow-white.png" loading="lazy" alt=""></div>
          </div>
          <div class="_wf-ss-saleblk _wf-ss-saleblksce">
            <div class="text-block-243">Dial 3 for<br><span class="text-span-30">Billing</span></div>
            <div class="_wf-ss-saleimage"><img src="assets/images/Billing_2Billing.png" loading="lazy" width="49" height="49" alt=""></div>
          </div>
          <div class="_wf-ss-saleblk _wf-ss-saleblksce">
            <div class="text-block-243">Dial 4 for<br><span class="text-span-30">Others</span></div>
            <div class="_wf-ss-saleimage"><img src="assets/images/others_1others.png" loading="lazy" width="49" height="49" alt=""></div>
          </div>
        </div>
      </div>
      <div class="_wf-ss-supportdiv">
        <div class="_wf-ss-blkhd _wf-ss-secblkhd">
          <div class="text-block-240">Support menu extensions</div>
        </div>
        <div class="_wf-ss-supportblksmain _wf-ss-webdiv">
          <div class="_wf-ss-smallmenublk">
            <div class="text-block-244">Extn #1 for<br><span class="text-span-30">Front Desk</span></div><img src="assets/images/desk_1desk.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #2 for<br><span class="text-span-30">Billing</span></div><img src="assets/images/Billing1_1Billing1.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #3 for<br><span class="text-span-30">IPD</span></div><img src="assets/images/IPD_1IPD.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #4 for<br><span class="text-span-30">Diagnostic</span></div><img src="assets/images/Diagnostic_2Diagnostic.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #5 for<br><span class="text-span-30">Pharmacy &amp; Inventor</span></div><img src="assets/images/inventory_1inventory.png" loading="lazy" width="70" height="70" alt="">
          </div>
        </div>
        <div class="_wf-ss-supportblksmain">
          <div class="_wf-ss-smallmenublk">
            <div class="text-block-244">Extn #6 for<br><span class="text-span-30">Doctor</span></div><img src="assets/images/Doctor_2Doctor.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #7 for<br><span class="text-span-30">ER</span></div><img src="assets/images/ER_1ER.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #8 for<br><span class="text-span-30">Nurse</span></div><img src="assets/images/Nurse_2Nurse.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
            <div class="text-block-244">Extn #9 for<br><span class="text-span-30">Others</span></div><img src="assets/images/others1_1others1.png" loading="lazy" width="70" height="70" alt="">
          </div>
          <!-- <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec _wf-ss-hideblk">
          <div class="text-block-244">Extn #1 for<br><span class="text-span-30">Front Desk</span></div><img src="assets/images/Rollout.png" loading="lazy" width="130" height="130" alt="">
        </div> -->
      </div>
    </div>
    <div class="_wf-ss-mainboedershadow">
      <div class="_wf-ss-blkhd">
        <div class="text-block-240">Support IVR Number</div>
      </div>
      <div class="_wf-ss-smallboxmain _wf-ss-mobilediv">
        <div class="_wf-ss-saleblk">
          <div class="text-block-243">Raise a ticket<span class="text-span-30"></span></div>
          <div class="_wf-ss-saleimage"><img src="assets/images/ticket2_1ticket2.png" loading="lazy" width="49" height="49" alt=""></div>
        </div>
        <div class="_wf-ss-mobileortxt">
          <div class="text-block-287">or</div>
        </div>
        <div class="_wf-ss-saleblk">
          <div class="text-block-243">Dial 1 for<br><span class="text-span-30">Sales</span></div>
          <div class="_wf-ss-saleimage"><img src="assets/images/sales_2sales.png" loading="lazy" width="49" height="49" alt=""></div>
        </div>
        <div data-w-id="7f8f1096-7adf-4fd1-f1f4-ffe41ad4a32b" class="_wf-ss-saleblk _wf-ss-saleblksce">
          <div class="text-block-243">Dial 2 for<br><span class="text-span-30">Support</span></div>
          <div class="_wf-ss-saleimage"><img src="assets/images/support_2support.png" loading="lazy" width="49" height="49" alt=""></div>
        </div>
        <div class="_wf-ss-smalldropdown" (click)="arrowClick()"><img src="assets/images/down-arrow-white_1down-arrow-white.png" loading="lazy" alt=""></div>
        @if (showSupport) {
          <div class="_wf-ss-blackbg">
            <div class="_wf-ss-smallsupportblk" (click)="arrowClick()">
              <div class="_wf-ss-mobilecrossicon" >
                <div class="text-block-288">.</div><img src="assets/images/circle-cross1_1circle-cross1.png" loading="lazy" alt="">
              </div>
              <div class="text-block-286">Support menu extension</div>
              <div class="_wf-ss-supportblksmain _wf-ss-mobilediv">
                <div class="_wf-ss-smallmenublk">
                  <div class="text-block-244">Extn #1 for<br><span class="text-span-30">Front Desk</span></div><img src="assets/images/desk_1desk.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #2 for<br><span class="text-span-30">Billing</span></div><img src="assets/images/Billing1_1Billing1.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #3 for<br><span class="text-span-30">IPD</span></div><img src="assets/images/IPD_1IPD.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #4 for<br><span class="text-span-30">Diagnostic</span></div><img src="assets/images/Diagnostic_2Diagnostic.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #5 for<br><span class="text-span-30">Pharmacy &amp; Inventor</span></div><img src="assets/images/inventory_1inventory.png" loading="lazy" width="50" height="50" alt="">
                </div>
              </div>
              <div class="_wf-ss-supportblksmain _wf-ss-mobilediv">
                <div class="_wf-ss-smallmenublk">
                  <div class="text-block-244">Extn #6 for<br><span class="text-span-30">Doctor</span></div><img src="assets/images/Doctor_2Doctor.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #7 for<br><span class="text-span-30">ER</span></div><img src="assets/images/ER_1ER.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #8 for<br><span class="text-span-30">Nurse</span></div><img src="assets/images/Nurse_2Nurse.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec">
                  <div class="text-block-244">Extn #9 for<br><span class="text-span-30">Others</span></div><img src="assets/images/others1_1others1.png" loading="lazy" width="50" height="50" alt="">
                </div>
                <!-- <div class="_wf-ss-smallmenublk _wf-ss-smallmenublksec _wf-ss-hideblk">
                <div class="text-block-244">Extn #1 for<br><span class="text-span-30">Front Desk</span></div><img src="assets/images/Rollout.png" loading="lazy" width="130" height="130" alt="">
              </div> -->
            </div>
          </div>
        </div>
      }
      <div class="_wf-ss-saleblk">
        <div class="text-block-243">Dial 3 for<br><span class="text-span-30">Billing</span></div>
        <div class="_wf-ss-saleimage"><img src="assets/images/Billing_2Billing.png" loading="lazy" width="49" height="49" alt=""></div>
      </div>
      <div class="_wf-ss-saleblk _wf-ss-saleblksce">
        <div class="text-block-243">Dial 4 for<br><span class="text-span-30">Others</span></div>
        <div class="_wf-ss-saleimage"><img src="assets/images/others_1others.png" loading="lazy" width="49" height="49" alt=""></div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="_wf-ss-blkhd _wf-ss-secblkhd">
  <div class="text-block-240">Alternatively you can raise a ticket or have a call with us</div>
</div>
<!-- <div class="_wf-ss-alteblkmain _wf-ss-mobilehide">
<div class="_wf-ss-altblk">
  <div class="_wf-ss-tickettxt">
    <div class="text-block-247">Raise a ticket</div>
    <div data-hover="" data-delay="0" class="dropdown-3 w-dropdown">
      <div class="dropdown-toggle-3 w-dropdown-toggle">
        <div class="icon w-icon-dropdown-toggle"></div>
        <div class="text-block-246">Select</div>
      </div>
      <nav class="w-dropdown-list">
        <a href="#" class="w-dropdown-link">Link 1</a>
        <a href="#" class="w-dropdown-link">Link 2</a>
        <a href="#" class="w-dropdown-link">Link 3</a>
      </nav>
    </div>
  </div>
  <div class="_wf-ss-frshworkimage"><img src="assets/images/fresgwirks-color-1.png" loading="lazy" width="70" height="" alt=""></div>
</div>
<div class="_wf-ss-altblk _wf-ss-videodiv">
  <div class="_wf-ss-tickettxt">
    <div class="text-block-247">Video call</div>
    <div data-hover="" data-delay="0" class="dropdown-3 w-dropdown">
      <div class="dropdown-toggle-3 w-dropdown-toggle">
        <div class="icon w-icon-dropdown-toggle"></div>
        <div class="text-block-246">Select</div>
      </div>
      <nav class="w-dropdown-list">
        <a href="#" class="w-dropdown-link">Link 1</a>
        <a href="#" class="w-dropdown-link">Link 2</a>
        <a href="#" class="w-dropdown-link">Link 3</a>
      </nav>
    </div>
  </div>
  <div class="_wf-ss-frshworkimage"><img src="assets/images/gg_1gg.png" loading="lazy" width="70" height="70" alt=""></div>
</div>
</div> -->
<div class="_wf-ss-alteblkmain">
  <div class="_wf-ss-altblk _wf-ss-videodiv">
    <div class="_wf-ss-mobile-videotab">
      <div class="_wf-ss-tickettxt _wf-ss-googlemeet">
        <div class="text-block-247 googlemeet">Google meet</div>
        <!-- <div data-hover="" data-delay="0" class="dropdown-3 w-dropdown">
        <div class="dropdown-toggle-3 w-dropdown-toggle">
          <div class="icon w-icon-dropdown-toggle"></div>
          <div class="text-block-246">Select</div>
        </div>
        <nav class="w-dropdown-list">
          <a href="#" class="w-dropdown-link">Link 1</a>
          <a href="#" class="w-dropdown-link">Link 2</a>
          <a href="#" class="w-dropdown-link">Link 3</a>
        </nav>
      </div> -->
    </div>
    <div class="_wf-ss-tcketimage _wf-ss-videocamimage"><img src="assets/images/gm_1gm.png" loading="lazy" width="80" alt=""></div>
  </div>
  <div class="_wf-ss-prrmiertxt">
    <div class="text-block-247 googlemeet">*Google meet video call only for premier customers</div>
  </div>
  <!-- <div class="_wf-ss-frshworkimage"><img src="assets/images/gg_1gg.png" loading="lazy" width="120" height="120" alt=""></div> -->
</div>
</div>
</div>
</div>